//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { Toast } from 'mint-ui'
export default {
  name: 'user-info-page',
  data() {
    return {
      TIME_COUNT: 60,
      timer: null,
      hospitals: [],
      doctors: [],
      form: {
        mobile: '',
        // card_password: '',
        nickname: '',
        sex: '',
        smsCode: '',
        birthday: '',
        email: '',
        hospitalId: '',
        hospitalDoctorId: '',
      },
      popupVisible: false,
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
    this.form = Object.assign({}, this.form, this.user)
    this.form.sex = this.form.sex !== 1 ? 'female' : 'male'
    this.getHospital()
    this.getHospitalDoctor()
  },
  methods: {
    signOut () {
      localStorage.clear('token')
      localStorage.clear('tokenExpiredAt')
      global.defaultStore.commit('SIGNOUT')
      this.$router.push({ path: '/phone' })
    },
    sendSMS () {
      const setTimer = () => {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (this.TIME_COUNT > 0) {
            this.TIME_COUNT--
            setTimer()
          } else {
            this.TIME_COUNT = 60
          }
        }, 1000)
      }
      if (!this.form.mobile) {
        return Toast({
          message: '請填寫手機號',
          duration: 3000
        })
      }
      if (this.TIME_COUNT !== 60) {
        return Toast({
          message: `請在${this.TIME_COUNT}秒後重新發送`,
          duration: 3000
        })
      }
      this.TIME_COUNT--
      setTimer()
      this.$store.httpDispatch({})('sendSMS', {
        mobile: this.form.mobile
      })
      .then((res) => {
        if (res.data.code === 0) {
          Toast({
            message: '發送成功',
            duration: 3000
          })
        }
      })
      .catch((err) => {
        Toast({
          message: `${err.data.code}: ${err.data.msg}`,
          duration: 5000
        })
      })
    },
    getHospital () {
      this.$store.httpDispatch({})('getHospitalsName').then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          this.hospitals = data.hospitals
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getHospitalDoctor () {
      this.$store.httpDispatch({})('getHospitalDoctors').then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          this.doctors = data.doctors
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onValuesChange(picker, values) {
      const pCitys = citys[provinceMap[values[0]]].map((c) => c.name)
      picker.setSlotValues(1, pCitys)
      this.form.province = values[0]
      this.form.city = values[1]
    },
    submit () {
      const body = Object.assign({}, this.form)
      if (!this.form.nickname) {
        return Toast({
          message: '請填寫用戶名',
          duration: 3000
        })
      }
      body.sex = this.form.sex !== 'female' ? 1 : 2
      this.$store.httpDispatch({})('updateUserInfo', body).then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          this.$store.httpDispatch({})('getUserInfo').then((res) => {
            const { code, data, msg } = res.data
            if (code === 0) {
              Toast({
                message: '資料修改成功',
                duration: 3000
              })
              this.$store.dispatch('setUser', { user: data.user })
              this.$router.push('/')
            } else if (code === 4000202) {
              return Toast({
                message: '驗證碼錯誤',
                duration: 3000
              })
            } else {
              console.log()
              return Toast({
                message: msg,
                duration: 3000
              })

            }
          }).catch((err) => {
            console.log(err)
              return Toast({
                message: msg,
                duration: 3000
              })
          })
        }
      }).catch((err) => {
        return Toast({
          message: err.data && err.data.msg,
          duration: 3000
        })
      })
    }
  }
}
